/**
 * Константы протокола, которые клиенту нужны во время работы.
 *
 * Свои копии, а не импорт из `@lumos/contracts`: корень пакета контрактов
 * тянет за собой все схемы, а с ними zod — сотню килобайт в главный чанк ради
 * трёх строк. Типы по-прежнему берутся оттуда (`import type` в сборку не
 * попадает), а совпадение значений сторожит `wire.test.ts`: разъедутся —
 * упадёт проверка, а не запросы у зрителей.
 */

/** Префикс API — тот же, что объявляет сервер. */
export const API_PREFIX = '/api/v1';

/** Заголовок double-submit CSRF-токена. */
export const CSRF_HEADER_NAME = 'x-csrf-token';

/** Заголовок версии клиента — по нему монитор отличает старую вкладку. */
export const APP_VERSION_HEADER_NAME = 'x-app-version';
